// removed by extract-text-webpack-plugin
module.exports = {"faq-container":"faq-container","faq-search-form":"faq-search-form","faq-input":"faq-input","faq-search-form-title":"faq-search-form-title","faq-btn-search":"faq-btn-search","faq-search-input-group":"faq-search-input-group","faq-item":"faq-item","title":"title","collapse":"collapse","down":"down","up":"up","faq-question":"faq-question","faq-answer":"faq-answer","faq-collapse":"faq-collapse"};


//////////////////
// WEBPACK FOOTER
// ./components/faq/style.scss
// module id = ./components/faq/style.scss
// module chunks = 0